export default __webpack_public_path__ + "static/media/back-icon.ce092202.svg";